module.exports = __webpack_public_path__ + "../resources/images/SkyCode_47-97dca05d4da7b601c7cc857425a149b7.svg";